import { DashboardModel } from "./../../routes/student/dashboard-route/dashboard/models/DashboardModel";
import { ProfileService } from "./profile.service";
import { IRoleServices } from "./IRoleServices";
import { IEmployeeContact } from "./parent.services.models";
import { IStudentResume } from "./../components/student-list-widget/models/IStudentResume";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable, of } from "rxjs";
import { catchError, map } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { OAuthService } from "angular-oauth2-oidc";
import { ContactModel } from "../components/contact-widget/models/ContactWidgetModel";
import { AppConfigService } from "src/app/services/app-config.service";
import { StudentMenuItem } from "../components/student-header-widget/models/Student-MenuItem";
import { StudentTransportRequest } from "../components/students-timeline/student-bus/models/Student-TransportRequest";
import { IStudentHealthConsent } from "../components/student-list-widget/models/IStudentHealthConsent";
import { CmdAddParentSurveyResponses } from "../components/parent-survey/parent-survey.component";
import { GoogleConsentFormResponse, GoogleConsentFormHistoryResponse, GoogleWorkspaceConsent } from "../models/google-workspace-consent"
import { SurveyQuestion } from "src/app/routes/shared/survey-manager-route/newtab-view/newtab-view.component";
import { IStudentHotspot } from "../components/students-timeline/student-hotspot/models/IStudentHotspot";
import { ParentDigitalHandbook, ParenDigitalHandbookResponse } from "src/app/routes/parent/dashboard-route/parent-digital-handbook/model/IParenDigitalHandbook";
import { IFeedNews } from './../components/feed-widget/models/IFeed';
import { IFeed } from 'src/app/shared/components/feed-widget/models/IFeed';
import { IStudentIEPStatus } from "../components/student-list-widget/models/ISpecialEdReports";
import { IStudentLEPStatus } from "./student.service.models";
import { IStudentsDeviceCheckedOut, IStudentsDeviceCheckedOutHistory } from "../components/students-timeline/student-devices-checked-out/model/IStudentsDeviceCheckedOut";
@Injectable({
  providedIn: "root",
})
export class ParentsService implements IRoleServices {
  baseUrl: string =this.appConfig.configuration.environment.endPoints.customerServices; //"https://localhost:44315"
  parentId: string = null;
  parentUsername: string = null;
  constructor(
    private appConfig: AppConfigService,
    private api: ApiService,
    private oauth: OAuthService
  ) {
    let identity = this.oauth.getIdentityClaims() as any;
    this.parentId = identity?.usernameNo;
    this.parentUsername = identity?.sub;
  }
  getContacts(id: string): Observable<ContactModel[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/contacts`;
    return this.api
      .get(path)
      .pipe(map((response) => response as ContactModel[]));
  }
  getStudentsByParent(): Observable<IStudentResume[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students`;
    return this.api
      .get(path)
      .pipe(map((response) => response as IStudentResume[]));
  }
  getStudentsByParentId(id): Observable<IStudentResume[]> {
    let path = `${this.baseUrl}/v1/parents/${id}/students`;
    return this.api
      .get(path)
      .pipe(map((response) => response as IStudentResume[]));
  }
  getStudentsByParentNoCacheAdmin(id): Observable<IStudentResume[]> {
    let path = `${this.baseUrl}/v1/parents/${id}/students`;
    return this.api
      .getNoCache(path)
      .pipe(map((response) => response as IStudentResume[]));
  }
  getStudentsByParentNoCache(): Observable<IStudentResume[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students`;
    return this.api
      .getNoCache(path)
      .pipe(map((response) => response as IStudentResume[]));
  }
  getSchoologyRemoteLogin(
    platform: string,
    schoologyId: string
  ): Observable<any> {
    let path = `${this.baseUrl}/v1/schoology/${this.parentId}/schoologyRemoteLogin?platform=${platform}&schoologyId=${schoologyId}`;
    return this.api.get(path).pipe(map((response) => response as any[]));
  }
  getSchoologyRemoteLoginAssigment(
    platform: string,
    schoologyId: string,
    taskId: string
  ): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/schoologyRemoteLogin?platform=${platform}&schoologyId=${schoologyId}&source=assignment&id=${taskId}`;
    return this.api.get(path).pipe(map((response) => response as any[]));
  }
  getSchoologyRemoteLoginCourse(
    platform: string,
    schoologyId: string,
    courseId: string
  ): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/schoologyRemoteLogin?platform=${platform}&schoologyId=${schoologyId}&source=course&id=${courseId}`;
    return this.api.get(path).pipe(map((response) => response as any[]));
  }
  getContactsByParent(): Observable<ContactModel[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/contacts`;
    return this.api
      .get(path)
      .pipe(map((response) => response as ContactModel[]));
  }
  getDashboardByParent(): Observable<DashboardModel> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/dashboard`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  getEsyLogin(): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/esyRemoteLogin`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  confirmStudent(registerModel: any) {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students/confirm`;
    let form = {
      studentId: registerModel.studentId,
      pin: registerModel.pinCode,
      birthDate: registerModel.birthDate,
    };
    return this.api
      .postForms(path, form)
      .pipe(map((response) => response as any));
  }
  addStudent(registerModel: any) {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students/add`;
    let form = {
      studentId: registerModel.studentId,
      pin: registerModel.pinCode,
      birthDate: registerModel.birthDate,
    };
    return this.api
      .postForms(path, form)
      .pipe(map((response) => response as any));
  }
  removeStudent(studentId: any, parentId: any = null) {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students/${studentId}`;
    return this.api.delete(path).pipe(map((response) => response as any));
  }
  removeStudent2(studentId: any, parentId: any) {
    let path = `${this.baseUrl}/v1/parents/${parentId}/students/${studentId}`;
    return this.api.delete(path).pipe(map((response) => response as any));
  }
  updateEmergencyContact(model: any): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students/`;
    return of(model);
  }
  getParentIdByMisisId(misisId: any): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${misisId}`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  
  updateRecentStudentMenuByParent(model: string) {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/recentmenu/${model}`;
    return this.api
      .post(path, {})
      .pipe(map((response) => response as any));
  }
  
  addfavoriteStudentMenuByParent(buttonId: string) {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/favorites/${buttonId}`;
      return this.api
      .post(path,{})
      .pipe(map((response) => response as any));
  }

  removeFavoriteStudentMenu(buttonId) {    
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/favorites/${buttonId}`;
    return this.api.delete(path).pipe(map((response) => response as any));
  }

  getFavoritesByParent(): Observable<StudentMenuItem[]> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/favorites`;
    return this.api
      .get(path)
      .pipe(map((response) => response as StudentMenuItem[]));
  }

  getRecentStudentMenuByParent(): Observable<StudentMenuItem> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/recentmenu`;
    return this.api
      .get(path)
      .pipe(map((response) => response as StudentMenuItem));
  }

  getGoogleConsentForm(studentId: string, schoolYear: string): Observable<GoogleConsentFormResponse> {
    const path = `${this.baseUrl}/v1/parents/${this.parentId}/GetGoogleConsentForm`;

    return this.api.getWithParams(path, {
      studentId: studentId,
      schoolYear: schoolYear
    }).pipe(
      map((response) => response as GoogleConsentFormResponse)
    );
  }

  getGoogleConsentFormHistory(studentId: string): Observable<GoogleConsentFormHistoryResponse> {
    const path = `${this.baseUrl}/v1/parents/${this.parentId}/GetGoogleConsentFormHistory`;

    return this.api.getWithParams(path, {
      studentId: studentId
    }).pipe(
      map((response) => response as GoogleConsentFormHistoryResponse)
    );
  }

  addGoogleConsentForm(consent: GoogleWorkspaceConsent): Observable<GoogleConsentFormResponse> {
    const path = `${this.baseUrl}/v1/parents/${this.parentId}/AddGoogleConsentForm`;
    return this.api.post(path, consent).pipe(
      map((response) => response as GoogleConsentFormResponse)
    );
  }

  updateGoogleConsentForm(consent: GoogleWorkspaceConsent): Observable<GoogleConsentFormResponse> {
    const path = `${this.baseUrl}/v1/parents/${this.parentId}/UpdateGoogleConsentForm`;
    return this.api.post(path, consent).pipe(
      map((response) => response as GoogleConsentFormResponse)
    );
  }

  addTransportationRequest(requestModel: any): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/students/${requestModel.studentId}/bus/request`;
    let form = {
      parentName: requestModel.parentName,
      submissionDate: requestModel.submissionDate,
      specialNeedsRequest: requestModel.specialNeedsRequest,
      currentSchoolYear: requestModel.currentSchoolYear,
      nextSchoolYear: requestModel.nextSchoolYear,
      isOptOut: requestModel.isOptOut
    };
    return this.api
      .postForms(path, form)
      .pipe(map((response) => response as any));
  }

  getStudentBusRequestStatus(studentId: any, schoolYear:any): Observable<StudentTransportRequest[]> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/students/${studentId}/bus/request/status?schoolYear=${schoolYear}`;
    return this.api
      .get(path)
      .pipe(map((response) => response as StudentTransportRequest[]));
  }  

  saveStudentHealthConsent(consents: IStudentHealthConsent[]): Observable<any> {
    let path = `${this.baseUrl}/v1/students/${this.parentId}/saveStudentHealthConsent`;
    return this.api.put(path, consents).pipe(map((response) => response as any));
  }

  getStudentHealthConsentByParentId(): Observable<IStudentHealthConsent[]> {
    let path = `${this.baseUrl}/v1/students/${this.parentId}/StudentHealthConsent`;
    return this.api.get(path).pipe(map((response) => response as IStudentHealthConsent[]));
  }

  getStudentHotspotByParentId(): Observable<IStudentHotspot[]> {
    let path = `${this.baseUrl}/v1/students/${this.parentId}/studentHotspotRequest`;
    return this.api.get(path).pipe(map((response) => response as IStudentHotspot[]));
  }

  getStudentHotspotEligibility(studentId: any): Observable<any> {
    let path = `${this.baseUrl}/v1/students/${studentId}/hotspotEligibility`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

  saveHotspotRequest(hotspotRequest: IStudentHotspot[]): Observable<any> {
    let path = `${this.baseUrl}/v1/students/${this.parentId}/saveStudentHotspotRequest`;
    return this.api.put(path, hotspotRequest).pipe(map((response) => response as any));
  }  

  getFeatureConfiguration(): Observable<any> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/feature/configuration`;
    return this.api
      .get(path)
      .pipe(map((response) => response as any));
  }

  getFeatureConfigurationByName(configurationName: string): Observable<any> {
    const path = `${this.baseUrl}/v1/parents/${this.parentUsername}/feature/configurationByName`;

    return this.api.getWithParams(path, { configurationName }).pipe(
      map(response => response as any)
    );
  }


  getFeatureMaintenance(): Observable<any> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/feature/maintenance`;
    return this.api
      .get(path)
      .pipe(map((response) => response as any));
  } 

  getDisableLoginButtonStatus(): Observable<any> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/feature/disableLoginButtonStatus`;
    return this.api
      .get(path)
      .pipe(map((response) => response as any));
  } 

  getTransportationBannerStatus(): Observable<any> {    
    let path = `${this.baseUrl}/v1/parents/${this.parentUsername}/feature/transportationBannerStatus`;
    return this.api
      .get(path)
      .pipe(map((response) => response as any));
  } 

  // getParentSurveysList(): Observable<any> {    
  //   let path = `${this.baseUrl}/v1/surveys`;
  //   return this.api
  //     .get(path)
  //     .pipe(map((response) => response as any));
  // } 

  getParentSurvey(surveyId:string): Observable<any> {    
    let path = `${this.baseUrl}/v1/survey/${surveyId}`;
    return this.api
      .get(path)
      .pipe(map((response) => response as any));
  } 

  getParentSurveysList(): Observable<any> {    
    let path = `${this.baseUrl}/v1/survey/parentId/${this.parentId}/all`;
    return this.api
      .get(path)
      .pipe(map((response) => response as any));
  } 

  addParentSurveyResponses(surveyId, requestModel: CmdAddParentSurveyResponses): Observable<any> {
    let path = `${this.baseUrl}/v1/survey/${surveyId}/parentId/${this.parentId}/submit`;
    return this.api
      .post(path, requestModel)
      .pipe(map((response) => response as any));
  }

  
   getParentDigitalHandbook(): Observable<ParentDigitalHandbook> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/parent-digital-handbook`;
    return this.api.getNoCache(path).pipe(map((response) => response as ParentDigitalHandbook));
  }

    addParentDigitalHandbook(requestModel: any): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/saveparentdigitalhandbook`;
    //return this.api.post(path, requestModel).pipe(map((response) => response as any));
    return this.api.post(path, requestModel);
  }

  loadConsentFormEnabled(): Observable<boolean> {
    return this.getFeatureConfigurationByName('google_consent_form_enabled').pipe(
      map((response: { name: string; value: string }) => {
        if (response && response.value) {
          const flag = response.value.trim().toUpperCase();
          return flag === 'Y';
        }
        console.warn('Consent form enabled flag missing or malformed. Returning false.');
        return false;
      }),
      catchError(error => {
        console.error('Error fetching config. Defaulting to disabled.', error);
        return of(false);
      })
    );
  }
  
  loadFieldtripEnabled(): Observable<boolean> {
    return this.getFeatureConfigurationByName('field_trip_enabled').pipe(
      map((response: { name: string; value: string }) => {
        if (response && response.value) {
          const flag = response.value.trim().toUpperCase();
          return flag === 'Y';
        }
        console.warn('Consent form enabled flag missing or malformed. Returning false.');
        return false;
      }),
      catchError(error => {
        console.error('Error fetching config. Defaulting to disabled.', error);
        return of(false);
      })
    );
  }

  getNewsRssFeeds(): Observable<IFeedNews[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/GetRSSNewsFeed`;
    return this.api.get(path).pipe(map((response) => response as IFeedNews[]));
  }

  getStaffRssFeeds(): Observable<IFeed[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/GetRSSNewsFeed`;
    return this.api.get(path).pipe(map((response) => response as IFeed[]));
  }

  getStudentIEPFlagStatus(studentId: string): Observable<IStudentIEPStatus> {
    const path = `${this.baseUrl}/v1/parents/${this.parentId}/GetStudentIEPFlagStatus/${studentId}`;
    return this.api.getWithParams(path, {
      studentId: studentId,
    }).pipe(
      map((response) => response as IStudentIEPStatus)
    );
  }

  getLangClassificationCode(studentId: string): Observable<IStudentLEPStatus> {
    const path = `${this.baseUrl}/v1/parents/${this.parentId}/GetLangClassificationCode/${studentId}`;
    return this.api.getWithParams(path, {
      studentId: studentId,
    }).pipe(
      map((response) => response as IStudentLEPStatus)
    );
  }
  
  getStudentsDevicesCheckedOut(): Observable<IStudentsDeviceCheckedOut[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/GetStudentsDevicesCheckedOut`;
    return this.api.get(path).pipe(map((response) => response as IStudentsDeviceCheckedOut[]));
  }
  
  saveStudentsDevicesCheckedOut(requestModel: any): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/saveStudentsDevicesCheckedOut`;
    return this.api.post(path, requestModel);
  }

  getStudentsDevicesCheckedOutHistory(): Observable<IStudentsDeviceCheckedOutHistory[]> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/GetStudentsDevicesCheckedOutHistory`;
    return this.api.get(path).pipe(map((response) => response as IStudentsDeviceCheckedOutHistory[]));
  }
  getConsentPortalLink(): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/consent-portal`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

  getConsentStatusApiUrl(): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${this.parentId}/consent-status-api-url`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

  getStudentConsentStatus(): Observable<any> {
     let path = `${this.baseUrl}/v1/parents/${this.parentId}/google-consent-status`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  getStudentBusRequestHistory(parentId: string, studentId: string): Observable<any> {
    let path = `${this.baseUrl}/v1/parents/${parentId}/${studentId}/bus-transport-request-history`;
    return this.api.get(path).pipe(map((response) => response as any));
  }

}
